import React from 'react'
import {
  Box,
  Card,
  styled,

} from '@mui/material';
import {  Tag } from "antd";

const CardHeader = styled(Box)(() => ({
    display: 'flex',
    paddingLeft: '24px',
    paddingRight: '24px',
    marginBottom: '12px',
    alignItems: 'center',
    justifyContent: 'space-between',
}));

const Title = styled('span')(() => ({
    fontSize: '1rem',
    fontWeight: '500',
    textTransform: 'capitalize',
}));
  

const AssignedRider = ({ order }) => {


if(!order?.rider){
    return <></>
}

  return (
    <div>
        <Card elevation={3} sx={{ pt: '20px', mb: 3 }}>
        <CardHeader>
          <a href={`/riders/${order?.rider?.id}`}>
            <Title style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}> 
                <span>Assigned Rider:  </span>  
                <Tag >{order?.rider?.name}</Tag>  
            </Title>
          </a>
        </CardHeader>
      </Card>
    </div>
  )
}

export default AssignedRider